import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
// component
import SFWhiteButton from '@/component/common/sf-white-button';
import SFDownloadIcon from '@/component/icons/sf-download-icon';
import SFNFTIcon from '@/component/icons/sf-nft-icon';
import SFSendIcon from '@/component/icons/sf-send-icon';
import { inter } from '@/theme';
import DownloadDrawer from '@/component/wallet/download-drawer';

import SumMyCoin from '@/component/wallet/SumMyCoin';
import { useTranslation } from 'react-i18next';

export default function ActionBtns() {
  const { t } = useTranslation();
  const [isDownloadDrawerOpen, setIsDownloadDrawerOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* <Typography variant="h2" color="white" mt={1.5} textAlign="right" mb={3} fontFamily={inter.style.fontFamily}>
        <SumMyCoin />
      </Typography> */}
      <Stack direction="row" gap={1}>
        <SFWhiteButton
          fullWidth
          size="large"
          variant="outlined"
          sx={{
            borderRadius: '100px !important',
          }}
          startIcon={<SFDownloadIcon />}
          onClick={() => {
            setIsDownloadDrawerOpen(true);
          }}
        >
          <Typography variant="body2" fontWeight={700}>
            {t('button.receive')}
          </Typography>
        </SFWhiteButton>
        <SFWhiteButton
          fullWidth
          size="large"
          variant="outlined"
          sx={{
            borderRadius: '100px !important',
          }}
          startIcon={<SFSendIcon />}
          onClick={() => {
            navigate('/sendForm');
          }}
        >
          <Typography variant="body2" fontWeight={700}>
            {t('button.send')}
          </Typography>
        </SFWhiteButton>
        <SFWhiteButton
          fullWidth
          size="large"
          variant="outlined"
          sx={{
            borderRadius: '100px !important',
          }}
          startIcon={<SFNFTIcon />}
          onClick={() => {
            navigate('/nft');
          }}
        >
          <Typography variant="body2" fontWeight={700}>
            NFT
          </Typography>
        </SFWhiteButton>
      </Stack>
      <DownloadDrawer
        open={isDownloadDrawerOpen}
        onClose={() => {
          setIsDownloadDrawerOpen(false);
        }}
      />
    </>
  );
}
